import React, { useState } from 'react';
import { object } from 'prop-types';
import { Button } from 'reactstrap';
import SVG from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import { STATIC_PATH } from '../../config';
import FaqGlossaryDictionary from './FaqGlossaryDictionary';
import FaqGlossaryLine from './FaqGlossaryLine';

const propTypes = {
  glossary: object.isRequired,
};

const defaultProps = {
  glossary: {},
};

const FaqGlossary = ({ glossary }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="faq-glossary">
      <div className="faq-glossary-header">
        <p className="faq-glossary-title">
          <FormattedMessage id="faq.glossary.title" defaultMessage="CPA Dictionary" />
        </p>

        <Button color="secondary" onClick={toggleCollapse}>
          <SVG
            src={`${STATIC_PATH}/img/action-icons/arrow.svg`}
            height="24"
            width="24"
            cacheRequests
            className={isCollapsed ? 'arrow-collapsed' : 'arrow-expanded'}
          />
        </Button>
      </div>

      <div className={isCollapsed ? 'faq-glossary-collapsed' : 'faq-glossary-expanded'}>
        <div className="faq-glossary">
          <p>
            <FormattedMessage
              id="faq.glossary.text"
              defaultMessage="The most complete dictionary on affiliate marketing, lead generation and CPA. Terms are replenished, if you want to see here some term that you do not understand and it relates to affiliate marketing — let us know."
            />
          </p>
          <div className="faq-glossary-line faq-glossary-line-main">
            {Object.keys(glossary).map((key) => (
              <FaqGlossaryDictionary glossary={glossary[key]} key={`FaqGlossaryABC_${key}`} />
            ))}
          </div>

          <div className="faq-glossary-items">
            {Object.keys(glossary).map((key) => (
              <FaqGlossaryLine
                glossary={glossary[key]}
                keys={Object.keys(glossary[key])}
                key={`FaqGlossaryLine_${key}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

FaqGlossary.propTypes = propTypes;
FaqGlossary.defaultProps = defaultProps;

export default FaqGlossary;
